import Layout from '@/views/layout/Index'

export const ManageRouter = [{
	path: '/manage',
	name: 'manage',
	component: Layout,
	meta: { title: '测评管理', icon: 'fa-group' },
	children: [
		{
			path: 'paper/list',
			component: () => import('@views/manage/PaperList'),
			name: 'eval-paper',
			meta: { title: '试卷管理', icon: 'fa-inbox' }
		},
		{
			path: 'company/list',
			component: () => import('@views/manage/CompanyList'),
			name: 'ev-company',
			meta: {title: '公司管理', icon: 'fa-black-tie'}
		},
		{
			hidden:true,
			path: 'company/project/list/:companyId',
			component: () => import('@views/manage/ProjectList'),
			name: 'project-list',
			meta: {title: '公司项目', icon: 'fa-leaf'}
		},
		{
			hidden: true,
			path: 'project/detail',
			name: 'project-detail',
			meta: { title:'项目详情', icon: 'fa-paw', auth:'none' },
			component: () => import('@views/manage/projectDetail')
		},
		{
			path: 'recharge/list',
			component: () => import('@views/manage/RechargeList'),
			name: 'ev-recharge',
			meta: {title: '充值管理', icon: 'fa-bitcoin'}
		},
		{
			path: 'program/list',
			component: () => import('@views/manage/ProgramList'),
			name: 'program-list',
			meta: {title: '标准方案', icon: 'fa-feed'}
		},
		{
			hidden:true,
			path: 'program/save',
			component: () => import('@views/manage/ProgramSave'),
			name: 'program-save',
			meta: {title: '标准方案保存', icon: 'fa-leaf'}
		},
		{
			path: 'person/list',
			component: () => import('@views/manage/PersonList'),
			name: 'person-list',
			meta: {title: '个人方案', icon: 'fa-podcast'}
		},
		{
			hidden:true,
			path: 'person/save',
			component: () => import('@views/manage/PersonSave'),
			name: 'person-save',
			meta: {title: '个人方案保存', icon: 'fa-leaf'}
		},
		{
			path: 'model/list',
			component: () => import('@views/manage/ModelList'),
			name: 'model-list',
			meta: {title: '模型管理', icon: 'fa-list-alt'}
		},{
			path: 'dictionarl/list',
			component: () => import('@views/manage/DictionariesList'),
			name: 'dictionarl-list',
			meta: {title: '字典管理', icon: 'fa-gg'}
		},{
			path: 'model/category/list',
			component: () => import('@views/manage/category/list'),
			name: 'category-list',
			meta: {title: '模型分类', icon: 'fa-modx '}
		},{
			path: 'model/category/list',
			hidden: true,
			component: () => import('@views/manage/category/save'),
			name: 'category-save',
			meta: {title: '添加分类', icon: 'fa-category'}
		},{
			path: 'model/post/list',
			component: () => import('@views/manage/post/PostTab'),
			name: 'post-list',
			meta: {title: '岗位管理', icon: 'fa-cubes'}
		}
	]
}]


